import React from "react";
import AjudaModal from "./AjudaModal";

function AjudaEntitats({ pestanya, onTancar }) {
  const contingut = CONTINGUT[pestanya] || CONTINGUT.clients;
  return (
    <AjudaModal
      id="entitats-ajuda-title"
      titol={contingut.titol}
      lead={contingut.lead}
      onTancar={onTancar}
    >
      {contingut.cos}
    </AjudaModal>
  );
}

const CONTINGUT = {
  clients: {
    titol: "Com funcionen els Clients",
    lead: "La fitxa del client és el punt de partida de contactes, treballs i pressupostos. No barreja l'obra amb la identitat de l'empresa o la persona.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Llista</h4>
          <ul>
            <li>Doble clic per consultar. El <strong>…</strong> obre Consultar, Modificar, Esborrar, Contactes, Treballs i Pressupostos.</li>
            <li>La cerca mira nom, nom comercial, NIF i població. <strong>Nou client</strong> obre la fitxa buida.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Dins de la fitxa</h4>
          <p>
            El subnav canvia de bloc: <strong>Dades</strong>, <strong>Contactes</strong>, <strong>Treballs</strong> i{" "}
            <strong>Pressupostos</strong>. Treballs i Pressupostos d'aquí són un resum; el botó t'obre la pantalla
            sencera ja filtrada per aquest client.
          </p>
        </section>
      </>
    ),
  },
  clientFitxa: {
    titol: "Com funciona la fitxa del Client",
    lead: "Identificació, adreça i classificació. Els contactes de persones van a la secció Contactes, no en aquesta fitxa.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Blocs</h4>
          <ul>
            <li>Nom o raó social, nom comercial, NIF i dades de contacte de l'entitat (telèfon i email generals).</li>
            <li>Adreça fiscal o de correspondència. Professió i tipus de client es poden crear amb <strong>+ Nou</strong> sense sortir.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Esborrar</h4>
          <p>No es pot esborrar si té treballs. Primer cal tancar o desvincular aquella feina.</p>
        </section>
      </>
    ),
  },
  contactes: {
    titol: "Com funcionen els Contactes",
    lead: "Persones vinculades a aquest client o proveïdor: qui truca, qui signa, qui coordina. No és la fitxa de l'empresa.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Llista</h4>
          <ul>
            <li>Doble clic per consultar. El <strong>…</strong> obre Consultar, Modificar o Esborrar.</li>
            <li><strong>Nou contacte</strong>: nom, telèfon, email i, si cal, adreça. Pots reutilitzar un contacte que ja existeix a l'empresa.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Compte amb els duplicats</h4>
          <p>
            Si les dades s'assemblen a un contacte existent, el programa et pregunta si el reutilitzes. Val la pena
            dir que sí: evites dues fitxes de la mateixa persona.
          </p>
        </section>
      </>
    ),
  },
  relacions: {
    titol: "Treballs i Pressupostos del client",
    lead: "Un resum del que aquest client té obert. Per treballar-hi de debò, obre la pantalla sencera.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Què veus</h4>
          <p>
            La llista de treballs o de pressupostos d'aquest client. <strong>Obrir a Treballs</strong> o{" "}
            <strong>Obrir a Pressupostos</strong> et porta allà amb el client ja filtrat.
          </p>
        </section>
      </>
    ),
  },
  proveidors: {
    titol: "Com funcionen els Proveïdors",
    lead: "Qui et ven materials o serveis. La fitxa alimenta els preus del catàleg i les ofertes de pressupostos i treballs.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Llista</h4>
          <ul>
            <li>Doble clic per consultar. El <strong>…</strong> obre Consultar, Modificar, Esborrar, Contactes, Empleats i Sucursals.</li>
            <li><strong>Nou proveïdor</strong> obre la fitxa. La cerca mira nom, NIF i població.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Dins de la fitxa</h4>
          <p>
            <strong>Dades</strong>, <strong>Contactes</strong>, <strong>Empleats</strong> (comercials del proveïdor) i{" "}
            <strong>Sucursals</strong>. Els preus d'un producte concret es posen a Productes → Preus proveïdors, no
            aquí.
          </p>
        </section>
      </>
    ),
  },
  proveidorFitxa: {
    titol: "Com funciona la fitxa del Proveïdor",
    lead: "Identificació, adreça i professió. Les persones de contacte van a Contactes; els comercials a Empleats i les seus a Sucursals.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Fitxa</h4>
          <p>
            Mateixa idea que un client: raó social, NIF, telèfon, adreça. La professió es pot crear amb{" "}
            <strong>+ Nou</strong>. No esborra si té productes amb preu associat. <strong>Empleats</strong> i{" "}
            <strong>Sucursals</strong> són seccions d'aquest proveïdor.
          </p>
        </section>
      </>
    ),
  },
  proveidorEmpleats: {
    titol: "Com funcionen els Empleats del proveïdor",
    lead: "Les persones comercials d'aquest proveïdor. No són els empleats de la vostra empresa: aquells van a Empleats del menú.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Llista</h4>
          <ul>
            <li>Doble clic per consultar. El <strong>…</strong> obre Consultar, Modificar i Esborrar (si hi tens permís).</li>
            <li><strong>Nou empleat</strong> obre la fitxa: nom, cognoms, telèfon i email.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Fitxa</h4>
          <p>
            Cal almenys un nom o cognom. El telèfon i l'email són opcionals. Els contactes generals del proveïdor van a
            la pestanya Contactes, no aquí.
          </p>
        </section>
      </>
    ),
  },
  sucursals: {
    titol: "Com funcionen les Sucursals",
    lead: "Delegacions o seus del proveïdor, amb adreça pròpia. La fitxa principal del proveïdor continua sent la seu principal.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Llista</h4>
          <ul>
            <li>Doble clic per consultar. El <strong>…</strong> obre Consultar, Modificar i Esborrar (si hi tens permís).</li>
            <li><strong>Nova sucursal</strong> obre la fitxa. L'àlies identifica la seu a la llista.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Fitxa</h4>
          <p>
            Àlies i adreça són obligatoris. Telèfons, emails i horari són opcionals. Si esborres la sucursal, l'adreça
            només s'elimina si no la fa servir cap altra fitxa.
          </p>
        </section>
      </>
    ),
  },
  empleats: {
    titol: "Com funcionen els Empleats",
    lead: "Fitxa de l'empresa: qui treballa amb vosaltres. L'horari, les absències i el fitxatge van a Gestió, no en aquesta llista.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Llista</h4>
          <ul>
            <li>Doble clic per consultar. El <strong>…</strong> obre Consultar, Modificar, Esborrar i, si hi tens accés, Gestió.</li>
            <li><strong>Nou empleat</strong> obre la fitxa de dades (nom, contracte, contacte).</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Gestió</h4>
          <p>
            Horari, absències, baixes, control horari, calendari i resum d'aquest empleat. El <strong>?</strong> de
            aquella pantalla explica la pestanya on ets.
          </p>
        </section>
      </>
    ),
  },
  empleatFitxa: {
    titol: "Com funciona la fitxa de l'Empleat",
    lead: "Dades personals i laborals de l'empresa. No és l'usuari d'accés a l'ERP: això va a Usuaris.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Fitxa</h4>
          <ul>
            <li>Nom, cognoms, contacte, adreça i dades de contracte o categoria.</li>
            <li>A consultar, <strong>Gestió</strong> (si hi tens permís) obre horari i absències d'aquesta persona.</li>
          </ul>
        </section>
      </>
    ),
  },
  contactesCerca: {
    titol: "Com funciona la cerca de Contactes",
    lead: "Directori ràpid de tota l'empresa: clients, proveïdors, empleats i contactes. Pensat per quan sona el telèfon.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Cercar</h4>
          <ul>
            <li>
              <strong>Qui truca</strong>: enganxa o escriu el número. El programa mira els dígits, no el format.
            </li>
            <li>
              <strong>Cerca</strong>: nom, email, adreça o origen (client, proveïdor…).
            </li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Obrir</h4>
          <p>
            Doble clic o el <strong>…</strong> obre la fitxa resum. Des d'allà pots anar a l'entitat (client,
            proveïdor…) si n'hi ha una de vinculada.
          </p>
        </section>
      </>
    ),
  },
};

export default AjudaEntitats;
